import styles from '../AdminTools.module.css'
import { ChangeEvent, useEffect, useState } from 'react'
import { useDeleteFinalAccounting } from '../../../../fetchData/mutations/finalAccounting/useDeleteFinalAccounting'
import { HeaderAlignedInput } from './AdminInputs/HeaderAlignedInput'
import { HeaderAlignedTaBortButton } from './AdminInputs/HeaderAlignedTaBortButton'

export const DeleteFinalAccounting = () => {
  const [projectId, setProjectId] = useState<string>('')
  const deleteFinalAccounting = useDeleteFinalAccounting()

  useEffect(() => {
    if (deleteFinalAccounting.data?.success) setProjectId('')
  }, [deleteFinalAccounting.data?.success])

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setProjectId(e.target.value)
  }

  const handleDelete = () => deleteFinalAccounting.mutate(projectId)

  return (
    <div className={styles.formContainer}>
      <h6 className={styles.inputGroupHeader}>Slutredovisning</h6>

      <HeaderAlignedInput
        label={'Projekt-id'}
        inputValue={projectId}
        handleChange={handleChange}
      />

      <HeaderAlignedTaBortButton
        handleClick={handleDelete}
        disabled={!projectId}
      />
    </div>
  )
}
